export const PlusCircle = () => (
  <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.66683 3.66683H6.3335V6.3335H3.66683V7.66683H6.3335V10.3335H7.66683V7.66683H10.3335V6.3335H7.66683V3.66683ZM7.00016 0.333496C3.32016 0.333496 0.333496 3.32016 0.333496 7.00016C0.333496 10.6802 3.32016 13.6668 7.00016 13.6668C10.6802 13.6668 13.6668 10.6802 13.6668 7.00016C13.6668 3.32016 10.6802 0.333496 7.00016 0.333496ZM7.00016 12.3335C4.06016 12.3335 1.66683 9.94016 1.66683 7.00016C1.66683 4.06016 4.06016 1.66683 7.00016 1.66683C9.94016 1.66683 12.3335 4.06016 12.3335 7.00016C12.3335 9.94016 9.94016 12.3335 7.00016 12.3335Z"
      fill="currentColor"
    />
  </svg>
)
